'use client'

import { useTranslations } from 'next-intl'
import {
  Box,
  Button,
  Center,
  Container,
  HStack,
  SimpleGrid,
  Text,
} from '@chakra-ui/react'
import { IGallery } from '@/_types'
import { Link, useRouter } from '@/i18n/navigation'
import UniversalHeader from '@/_components/Header'
import SeoPageTitle from '@/_components/SeoPageTitle'
import {
  PaginationItems,
  PaginationNextTrigger,
  PaginationPrevTrigger,
  PaginationRoot,
} from '@/components/ui/pagination'
import { useSearchParams } from 'next/navigation'
import GalleryCard from '../Card'

const Mobile = ({
  data,
  count,
}: {
  data: IGallery[]
  count: number | string
}) => {
  const t = useTranslations()
  const searchParams = useSearchParams()
  const router = useRouter()
  const page = searchParams.get('page')

  if (!data?.length) {
    return (
      <>
        <UniversalHeader backLink='/profile' title={t('gallery')} />
        <SeoPageTitle>{t('gallery')}</SeoPageTitle>
        <Container>
          <Center flexDir='column' minH='80vh'>
            <Text fontWeight={600} fontSize='xl' mt={4} mb={2}>
              {t('no_images_yet')}
            </Text>
            <Text mb={4} color='text.muted' textAlign='center' maxW='450px'>
              {t('gallery_will_be_updated_soon')}
            </Text>
            <Link href={'/'}>
              <Button
                bg='primary'
                color='primary.text'
                _hover={{
                  bg: 'primary.hover',
                }}
                size={'xl'}
                rounded={16}
                height={'56px'}
              >
                {t('back_to_home')}
              </Button>
            </Link>
          </Center>
        </Container>
      </>
    )
  }

  return (
    <>
      <UniversalHeader backLink='/profile' title={t('gallery')} />
      <SeoPageTitle>{t('gallery')}</SeoPageTitle>
      <Box px={4} mt={2} pb={4}>
        <SimpleGrid columns={2} gap={2}>
          {data?.map((el) => (
            <GalleryCard key={el.id} data={el} />
          ))}
        </SimpleGrid>
      </Box>
      {Number(count) > 10 && (
        <Center my={4}>
          <PaginationRoot
            count={Number(count)}
            pageSize={10}
            defaultPage={1}
            page={Number(page) || 1}
            onPageChange={(e) => router.push(`?page=${e.page}`)}
            variant='subtle'
          >
            <HStack>
              <PaginationPrevTrigger />
              <PaginationItems  />
              <PaginationNextTrigger />
            </HStack>
          </PaginationRoot>
        </Center>
      )}
    </>
  )
}

export default Mobile
